import { Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { ONBOARDING_ROUTES } from "@/shared/constants/paths";
import { AccountPage } from "@/pages/onboarding/account/OnboardingAccountPage";

export const onboardingRoutes = (
  <>
    <Route
      path={ONBOARDING_ROUTES.ACCOUNT}
      element={
        <>
          <Helmet>
            <title>Get started - Elayne</title>
          </Helmet>
          <AccountPage />
        </>
      }
    />
  </>
);
